import { Grid } from '@mui/material';
import React from 'react';

import { headerStyles } from './styles';
import { HeaderLogosProps } from './types';

const HeaderLogos: React.FC<HeaderLogosProps> = (props) => {
    const { clientLogoUrl } = props;

    const classes = headerStyles(props);

    if (clientLogoUrl && typeof clientLogoUrl === 'string') {
        return (
            <Grid
                alignItems='center'
                className={classes.root}
                container
                direction='row'
                wrap='nowrap'
            >
                <img
                    className={classes.headerLogo}
                    data-testid='HeaderLogos-singleHeaderLogo'
                    src={clientLogoUrl}
                />
            </Grid>
        );
    }

    if (clientLogoUrl && Array.isArray(clientLogoUrl)) {
        return (
            <Grid
                alignItems='center'
                className={classes.root}
                container
                direction='row'
                wrap='nowrap'
            >
                {clientLogoUrl.map((url, i) => (
                    <React.Fragment key={url}>
                        <img
                            className={classes.headerLogo}
                            data-testid={`HeaderLogos-multiHeaderLogo-${i}`}
                            src={url}
                        />
                        {i !== clientLogoUrl.length - 1 &&
                            <div className={classes.headerLogoDivider} />}
                    </React.Fragment>
                ))}
            </Grid>
        );
    }

    return <></>;
};

export default HeaderLogos;